import { useState, lazy, Suspense } from "react";
import CircularProgress from "components/modals/Loading";
import { componentLoader } from "components/helpers";
import tick from "assets/tick-circle.png";

const PracticeSettings = lazy(() =>
  componentLoader(() => import("pages/provider/PracticeSettings")),
);

const OfficeHours = lazy(() =>
  componentLoader(() => import("pages/provider/OfficeHours")),
);

const OfficeClosure = lazy(() =>
  componentLoader(() => import("pages/provider/OfficeClosure")),
);

const AnsweringService = lazy(() =>
  componentLoader(() => import("pages/provider/AnsweringService")),
);

const tabs = [
  { title: "Practice Details", value: "practice details" },
  { title: "Office Hours", value: "office hours" },
  { title: "Office Closure", value: "office closure" },
  { title: "Answering Service", value: "answering service" },
];

const TabComponent = ({ value, title, screen, setScreen, validation }) => {
  const tab = value !== screen ? "tab notSelected" : "tab selected";
  return (
    <button className={tab} onClick={() => setScreen(value)}>
      {title}{" "}
      <img src={tick} alt="submitted" />
    </button>
  );
};

const AllCETabs = ({
  practice_id,
  patient,
  disabled,
  ceState,
  ceDispatch,
  charge_entry_id,

  fetchInsuranceList,
  fetchIllness,
  fetchCharges,
  fetchChargeEntry,
  fetchNotes,
  fetchPayment,
 

  updateBillingProvider,

  onChangeCEInsurance,
  openScreen,
}) => {
  const [screen, setScreen] = useState(openScreen || "practice details");

  const validation = {
    payment: "",
    PracticeSettings: ""
  }

  const showScreen = (s) => {
    switch (s) {
      case "practice details":
        return (
          <PracticeSettings />
        );
      case "office hours":
        return (
          <OfficeHours />
        );
      case "office closure":
        return (
          <OfficeClosure />
        );
      case "answering service":
        return (
          <AnsweringService />
        );
      default:
        return null;
    }
  };
  return (
    <>
      <div className="tab-container  mt-16" style={{ backgroundColor: '#E8E8E8' }}>
        {tabs.map((tab) => (
          <TabComponent
            key={tab.title}
            title={tab.title}
            value={tab.value}
            screen={screen}
            setScreen={setScreen}
            validation={validation}
          />
        ))}
      </div>
      <div className="mainScreen">
        <Suspense fallback={<CircularProgress />}>
          {showScreen(screen)}
        </Suspense>
      </div>
    </>
  );
};

export default AllCETabs;
